import { FC } from "react";

import styled from "styled-components";

import MuiInputLabel from "@mui/material/InputLabel";

interface IInputLabelProps {
  htmlFor?: string;
  label: string;
}
const InputLabel: FC<IInputLabelProps> = ({ htmlFor, label }) => {
  return <StyledInputLabel htmlFor={htmlFor}>{label} *</StyledInputLabel>;
};

export default InputLabel;

const StyledInputLabel = styled(MuiInputLabel)`
  color: black !important;
`;
